import {startCase} from "lodash"
import {ManagedSolutionsUser} from "../../resources/managedSolutions"

export type FunnelTone = "neutral" | "info" | "warning" | "success" | "danger"

export interface FunnelStage {
	label: string
	detail?: string
	tone: FunnelTone
}

// Collapses the raw form/application state into a single position in the activation funnel:
// Invited -> Onboarding -> In Review -> Approved -> Activated (and Denied as the failure branch).
export function deriveFunnelStage(user: ManagedSolutionsUser): FunnelStage {
	const {applicationFormStage, applicationStatus} = user.attributes
	const hasForm = Boolean(user.relationships?.applicationForm?.data?.id)
	const hasApplication = Boolean(user.relationships?.application?.data?.id)
	const hasCustomer = Boolean(user.relationships?.customer?.data?.id)
	const appStatus = applicationStatus?.toLowerCase()

	if (appStatus === "denied") {
		return {label: "Denied", tone: "danger"}
	}
	if (hasCustomer) {
		return {label: "Activated", tone: "success"}
	}
	if (appStatus === "approved") {
		return {label: "Approved", tone: "success"}
	}
	if (hasApplication) {
		return {label: "In Review", detail: applicationStatus ? startCase(applicationStatus) : undefined, tone: "warning"}
	}
	if (hasForm) {
		return {
			label: "Onboarding",
			detail: applicationFormStage ? startCase(applicationFormStage) : undefined,
			tone: "info",
		}
	}
	return {label: "Invited", tone: "neutral"}
}
